var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-flex",
    { attrs: { xs12: "", sm12: "", "pa-4": "", layout: "", wrap: "" } },
    [
      _c(
        "v-flex",
        { attrs: { xs12: "", sm6: "", md3: "" } },
        [
          _c("v-autocomplete", {
            attrs: {
              label: "Tipo de Fecha",
              "prepend-icon": "edit_calendar",
              "return-object": "",
              required: "",
              items: _vm.filterApi.TYPE_DATES,
              "item-text": "name_date",
              "item-value": "id_date"
            },
            on: { change: _vm.handleFilters },
            model: {
              value: _vm.paramApi.typeDate,
              callback: function($$v) {
                _vm.$set(_vm.paramApi, "typeDate", $$v)
              },
              expression: "paramApi.typeDate"
            }
          })
        ],
        1
      ),
      _c(
        "v-flex",
        { attrs: { xs12: "", sm6: "", md3: "" } },
        [
          _c("DatePicker", {
            attrs: { label: _vm.startDateName },
            model: {
              value: _vm.paramApi.start_date,
              callback: function($$v) {
                _vm.$set(_vm.paramApi, "start_date", $$v)
              },
              expression: "paramApi.start_date"
            }
          })
        ],
        1
      ),
      _c(
        "v-flex",
        { attrs: { xs12: "", sm6: "", md3: "" } },
        [
          _c("DatePicker", {
            attrs: { label: _vm.endDateName },
            model: {
              value: _vm.paramApi.end_date,
              callback: function($$v) {
                _vm.$set(_vm.paramApi, "end_date", $$v)
              },
              expression: "paramApi.end_date"
            }
          })
        ],
        1
      ),
      _c(
        "v-flex",
        { attrs: { xs12: "", sm6: "", md3: "" } },
        [
          _c("v-autocomplete", {
            attrs: {
              label: "Cliente",
              items: _vm.filterApi.CLIENTES,
              "item-text": "cliente",
              "item-value": "rut_cliente",
              clearable: "",
              "return-object": "",
              "prepend-icon": "apartment"
            },
            on: { change: _vm.handleFilters },
            model: {
              value: _vm.paramApi.cliente,
              callback: function($$v) {
                _vm.$set(_vm.paramApi, "cliente", $$v)
              },
              expression: "paramApi.cliente"
            }
          })
        ],
        1
      ),
      _c(
        "v-flex",
        { attrs: { xs12: "", sm6: "", md3: "" } },
        [
          _c("v-autocomplete", {
            attrs: {
              label: "Estado Conecta",
              items: _vm.filterApi.ESTADOS,
              "item-text": "estado",
              "item-value": "id_estado_conecta",
              "return-object": "",
              clearable: "",
              "prepend-icon": "filter_list"
            },
            on: { change: _vm.handleFilters },
            model: {
              value: _vm.paramApi.estado_conecta,
              callback: function($$v) {
                _vm.$set(_vm.paramApi, "estado_conecta", $$v)
              },
              expression: "paramApi.estado_conecta"
            }
          })
        ],
        1
      ),
      _c(
        "v-flex",
        {
          attrs: {
            xs12: "",
            sm6: "",
            md3: "",
            layout: "",
            "justify-center": "",
            wrap: "",
            "mt-2": ""
          }
        },
        [
          _c(
            "v-btn",
            { on: { click: _vm.handleSearchFilter } },
            [
              _c("v-icon", { attrs: { color: "#27488e" } }, [_vm._v("search")]),
              _vm._v("Filtrar\n    ")
            ],
            1
          ),
          _c(
            "v-btn",
            {
              on: {
                click: function($event) {
                  return _vm.handleCleanFilters()
                }
              }
            },
            [
              _c("v-icon", { attrs: { color: "#27488e" } }, [_vm._v("clear")]),
              _vm._v("Limpiar\n    ")
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }